import React from 'react';
import { View } from 'react-native';

export default ({ C, left, averageColor }: { left: number; averageColor: string; C: (color: string) => string }) => {
  return (
    <View
      style={{
        width: 1,
        height: 14,
        backgroundColor: C(averageColor),
        position: 'absolute',
        left,
        top: -1,
      }}
    />
  );
};
